<template>
	<div class="cover" :style="{background: `url(${productDetail.productUrl}) no-repeat`}">

<!--    //	background: url("https://ddlg-zhongtai-dev-1257088705.cos.ap-guangzhou.myqcloud.com/project/58d4ea31-4205-4218-b9a2-d95af5358236.png") no-repeat;-->
		<div class="content">
      <div class="title_box">
        <div class="title">{{productDetail.productName||''}} </div>
        <div class="discribe">{{productDetail.productExplain||''}} </div>
      </div>
			<div class="btns flex flex-start">
        <div class="btn_item" v-for="item in productDetail.xcProductButtonList">
        <button @click="clickProBtn(item)"
  :class="[item.styleId==0?'type2':item.styleId==1?'type1':'type3','cursorPointer','btn']" >{{item.buttonName||''}}</button>
          <img
              :class="{'fade-in': true, 'show': item.buttonType == 0}"
              v-if="item.buttonType == 0"
              :src="item.buttonUrl"
          />
        </div>
<!--				<button class="btn type1 cursorPointer" @click="tofindJob">使用产品</button>-->
<!--				<button class="btn type2 cursorPointer" @click="tofindJob">使用产品</button>-->
<!--				<button class="btn type3 cursorPointer" @click="tofindJob">使用产品</button>-->
			</div>
		</div>
		<el-dialog show-close title="申请成为供应商" :visible.sync="dialogFormVisible">
			<el-form ref="form" :model="form" label-width="10px">
				<el-form-item label="">
					<el-input style="width:70%" v-model="form.uname" placeholder="请输入你的姓名"> <i slot="prefix"
							class="el-input__icon el-icon-user-solid"></i></el-input>
				</el-form-item>
				<el-form-item label="">
					<el-input style="width:70%" v-model="form.phone" placeholder="请输入您的电话号码"> <i slot="prefix" class="el-input__icon el-icon-mobile-phone
"></i></el-input>
				</el-form-item>
				<el-form-item label="">
					<el-input style="width:70%" v-model="form.remark" placeholder="请输入您的公司全称（个人可不填）"> <i slot="prefix"
							class="el-input__icon el-icon-user-solid"></i></el-input>
				</el-form-item>
				<el-form-item label="">
					<el-input style="width:70%" v-model="form.trades" placeholder="请输入你所在的位置"> <i slot="prefix"
							class="el-input__icon el-icon-location-outline"></i></el-input>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer" style="margin:0 auto">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
    props:{
      productDetail: {
        type: Object,
        default: () => {},
      }
    },
		data() {
			return {
				dialogFormVisible: false,
				consultType: '',
				city: '',
				form: {
					uname: '',
					phone: '',
					remark: '', //请输入您的公司全称
					trades: '', //你所在的位置
				}
			}
		},
		methods: {
      clickProBtn(item){
        // 1-链接 0-图片 2- 文字
        if(item.buttonType==1){
            window.open(item.buttonUrl)
        }
      },
			tofindJob() {
				this.$router.push("/home/jobs");
			},
			tobeSupplier() {
				this.dialogFormVisible = true;
			},
			confirm() {
				let isError = false;
				let content = '';
				if (!this.form.phone) {
					isError = true;
					content = '请输入您的电话号码'
				};
				if (!this.form.uname) {
					isError = true;
					content = '请输入姓名'
				};
				if (!this.form.trades) {
					isError = true;
					content = '请输入你所在的位置'
				};
				if (isError) {
					this.$message({
						message: content,
						type: 'warning'
					});
					return
				}
				this.form.ctid = '10';
				axios({
					url: 'https://www.din-job.com/join',
					method: 'POST',
					data: this.form,
					headers: {
						'content-type': 'application/json',
					},
				}).then((res) => {
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					for (const obj in this.form) {
						this.form[obj] = '';
					}
					this.dialogFormVisible = false;
				}).catch((err) => {
					this.$message({
						message: '提交异常，请联系管理员',
						type: 'error'
					});
				});
			}
		},
	}
</script>

<style scoped lang="scss">
	.cover {
		width: 100%;
		height: 600px;
		// background: url("https://ddlg-zhongtai-dev-1257088705.cos.ap-guangzhou.myqcloud.com/project/58d4ea31-4205-4218-b9a2-d95af5358236.png") no-repeat;
		background-size: 110% 100%;
		position: relative;

		.content {
			position: absolute;
			top: 35%;
      padding-right: 70px;
			left: 14vw;
      .title_box{
        text-align: left;
        color: #fff;
        margin-top: -10px;
        .title{
          font-size: 40px;
          font-weight: 550;
        }
        .discribe{
          font-size: 20px;
          margin-top: 26px;
          max-width: 60ch;
          word-break: break-all;
          white-space: normal;
		  letter-spacing: 2px;
        }
      }
			h1 {
				text-align: left;
				font-size: 55px;
				font-family: Alibaba-PuHuiTi-H, Alibaba-PuHuiTi;
				font-weight: normal;
				color: #FFFFFF;
				line-height: 82px;
			}

			p {
				height: 42px;
				font-size: 24px;
				font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
				font-weight: normal;
				color: #FFFFFF;
				margin-top: 20px;
			}

			.btns {
				margin-top: 105px;
        .btn_item{
          position: relative;
        }
        img{
          width: 200px;
          height: 200px;
          position: absolute;
          top: 50px;
          left: 0;
          z-index:99;
          display: none;
        }
        /* 添加渐显效果的 CSS */
        .fade-in {
          opacity: 0;
          transition: opacity 1s ease-in;
        }

        .fade-in.show {
          opacity: 1;
        }
				.btn {
          width: 180px;
          height: 48px;
          background-color: #fff;
					line-height: 48px;
          border-radius: 2px;
					border: 0;
					font-size: 18px;
					font-weight: 500;
				}
        .btn:hover + img{
          display: block;
        }

				.type1 {
          color: #2F99F1;
					margin-right: 68px;
          border: 1px solid #1C51A3;
					//background: linear-gradient(90deg, #4B4FFF 0%, #0494FF 100%);
					transition: 200ms;
				}
        .type2 {
          color: #fff;
          margin-right: 68px;
          border: 1px solid #fff;
          background: transparent;
          transition: 200ms;
        }
        .type3 {
          color: #fff;
          margin-right: 68px;
          border: none;
          background: transparent;
          transition: 200ms;
        }
				.type1:hover {
					opacity: 0.7;
				}

				.createJob {
					color: #fff;
					background: rgba(255, 255, 255, 0.6);
					transition: 200ms;
				}

				.createJob:hover {
					opacity: 0.8;
				}
			}
		}
	}
</style>
